import { Component, Inject, OnInit } from '@angular/core';
import { AssetInput } from "@think-it-labs/edc-connector-client";
import { MatDialogRef } from "@angular/material/dialog";
import { StorageType } from "../../models/storage-type";

@Component({
  selector: 'edc-demo-asset-editor-dialog',
  templateUrl: './asset-editor-dialog.component.html',
  styleUrls: ['./asset-editor-dialog.component.scss']
})
export class AssetEditorDialog implements OnInit {
  id: string = '';
  version: string = '1.0';
  name: string = '';
  contenttype: string = 'application/json';

  storageTypeId: string = 'HttpProxy';
  account: string = '';
  container: string = 'src-container';
  blobname: string = '';
  baseUrl: string = '';

  constructor(private dialogRef: MatDialogRef<AssetEditorDialog>,
      @Inject('STORAGE_TYPES') public storageTypes: StorageType[]) {
  }

  ngOnInit(): void {
  }

  onSave() {
    let assetInput = {
      "@context": {
        "@vocab": "https://w3id.org/edc/v0.0.1/ns/"
      },
      "@id": this.id,
      properties: {
        "name": this.name,
        "version": this.version,
        "contenttype": this.contenttype,
      },
      dataAddress: {}
    }

    if (this.storageTypeId === 'HttpProxy') {
      assetInput.dataAddress = {
        "type": "HttpData",
        "name": this.name,
        "baseUrl": this.baseUrl,
        "proxyPath": "true",
        "proxyQueryParams": "true"
      }
    } else {
      assetInput.dataAddress = {
        "type": this.storageTypeId,
        "name": this.name,
        "account": this.account,
        "container": this.container,
        "blobname": this.blobname,
        "keyName": `${this.account}-key1`
      }
    }
    this.dialogRef.close({ assetInput });
  }
}
